import styled from 'styled-components';
import { breakpoints, fonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import { ISkeleton } from '@vfit/shared/components';

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 287px;

  @media (min-width: ${breakpoints.tablet}) {
    width: 366px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    width: 406px;
  }
`;

export const Title = styled.div`
  padding: 32px 0 16px;
  font-family: ${fonts.exbold};
  text-align: center;
  font-weight: 400;
  ${pxToCssFont(30, 38)}

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(42, 52)}
    padding: 60px 0 16px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 45)}
  }
`;

export const Text = styled.div`
  font-family: ${fonts.regular};
  font-style: normal;
  margin-bottom: 32px;
  text-align: center;
  font-weight: 400;
  ${pxToCssFont(20, 26)}

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 30)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-bottom: 40px;
  }
`;

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(16)};

  @media (min-width: ${breakpoints.tablet}) {
    gap: ${pxToRem(20)};
  }

  div {
    margin-top: 0;
  }

  p {
    position: relative;
    margin-bottom: 0;
  }
`;

export const Footer = styled.div`
  display: flex;
  font-family: ${fonts.regular};
  font-style: normal;
  font-weight: 400;
  ${pxToCssFont(14, 18)}
  margin-top: ${pxToRem(16)};
  margin-bottom: ${pxToRem(32)};

  @media (min-width: ${breakpoints.tablet}) {
    margin-top: ${pxToRem(20)};
  }
`;

export const skeletonShape: ISkeleton = {
  margins: [60, 30],
  tabletMargins: [32, 15],
  groups: [
    { heights: 60, marginBottom: 15 },
    { heights: 90, marginBottom: 32 },
    { heights: 60, repeat: 4, gap: 15 },
  ],
};
